import FilterTypes from '@constants/FilterTypes';
import { actionTypes } from '../reducer';
function onToggleFilter(fieldName, dispatch) {
    return () => {
        dispatch({
            type: actionTypes.FILTER_TOGGLED,
            field: fieldName
        });
    };
}
function onChangeDateFilter(fieldName, dispatch) {
    return (dateFieldName, value) => {
        dispatch({
            type: actionTypes.DATE_RANGE_FILTER_CHANGED,
            field: fieldName,
            dateField: dateFieldName,
            value
        });
    };
}
export default function getFiltersList({ filters, dispatch, buildingOptions = [], buildingId }) {
    function onChange(filterKey, value) {
        const newValues = Object.assign(Object.assign({}, filters.values), { [filterKey]: value });
        dispatch({
            type: actionTypes.FILTER_CHANGED,
            filters: Object.assign(Object.assign({}, filters), { values: newValues })
        });
    }
    const mappedBuildingOptions = buildingOptions.map((opt) => ({
        title: opt.label || opt.title,
        value: opt.value
    }));
    const resolvedType = buildingId ? FilterTypes.BooleanSelect : FilterTypes.Hidden;
    const buildingType = buildingId ? FilterTypes.Hidden : FilterTypes.GenericMultiSelect;
    return [
        {
            type: resolvedType,
            field: 'resolved',
            locale: 'resolved',
            active: filters.active.resolved,
            value: filters.values.resolved,
            onChange: (value) => onChange('resolved', value),
            onToggle: onToggleFilter('resolved', dispatch)
        },
        {
            type: buildingType,
            field: 'building',
            locale: 'building',
            active: filters.active.building,
            value: filters.values.building,
            optionsForSelect: mappedBuildingOptions,
            onChange: (value) => onChange('building', value),
            onToggle: onToggleFilter('building', dispatch)
        },
        {
            type: FilterTypes.DateRangePicker,
            field: 'dateOpened',
            locale: 'date_opened',
            active: filters.active.dateOpened,
            values: filters.values.dateOpened,
            onChange: onChangeDateFilter('dateOpened', dispatch),
            onToggle: onToggleFilter('dateOpened', dispatch)
        }
    ];
}
